/** Date parts by type. en-US for the short month: en-GB's ICU spells September "Sept". */
export function englishDateParts(
  instant: Date,
  options: Intl.DateTimeFormatOptions
): Record<string, string> {
  const parts: Record<string, string> = {};
  for (const p of new Intl.DateTimeFormat("en-US", options).formatToParts(instant)) {
    parts[p.type] = p.value;
  }
  return parts;
}
